<template>
<div>
<Apptab />
<v-container>
    <h1>Kontoinställningar</h1>
  <h3>Profil</h3>
  <v-form ref="form">
            <v-row class="justify-between">
                <v-text-field
                    v-model="fname"
                    :rules="nameRules"
                    label="Förnamn"
                    style="margin-left:10px"
                    required
                ></v-text-field>
                <v-text-field
                    v-model="lname"
                    :rules="nameRules"
                    label="Efternamn"
                    required
                ></v-text-field>
            </v-row>
            <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Din mail"
                required
            ></v-text-field>

            <v-alert type="success" v-show="alert" dismissible>
            Profil uppdaterad.
            </v-alert>
            <v-btn
                style="background-color:#ffa500"
                class="mr-4"
                v-on:click="submit"
                :loading="loading"
            >
                Uppdatera profil
            </v-btn>
        </v-form>
        <v-row class="mt-5">
        <h3>Ändra lösenord</h3>
        </v-row>
        <v-row>
  <v-btn
        text
        class="themecolor"
        to="/changepassword"
      >
        Ändra lösenord
      </v-btn>
       </v-row>
       
        <v-row class="mt-5">
        <h3>Radera konto</h3>
        </v-row>
        <v-row>
  <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Radera konto
        </v-btn>
      </template>

      <v-card>
          <v-card-title
          primary-title
        >
        </v-card-title>
        <v-card-text>
           Are you sure to delete your account?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteAccount"
          >
            Radera konto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
       </v-row>
  </v-container>
  
  </div>
</template>


<script>
import Apptab from "./apptab";
import store from "../../../store";
import axios from "axios";
  export default {
  components: {
    Apptab,
  },
    data () {
      return {
        store: store,
        user: [],
        loading: false,
        valid: false,
        alert: false,
        dialog: false,
        fname: "",
        lname: "",
        nameRules: [v => !!v || "Namn krävs"],
        email: "",
        cnfpass: "",
        emailRules: [
            v => !!v || "Din mail krävs",
            v => /.+@.+\..+/.test(v) || "Ange giltigt e-postmeddelande"
        ],
      }
    },
    created: async function() {
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}user/${this.store.state.user.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.user = resp.data.user;
        this.fname = this.user.first_name
        this.lname = this.user.last_name
        this.email = this.user.email
    },
    
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        async submit() {
            this.loading = true;
            await this.validate();
            let bodyFormData = new FormData();
            bodyFormData.set("id", this.user.id);
            bodyFormData.set("first_name", this.fname);
            bodyFormData.set("last_name", this.lname);
            bodyFormData.set("email", this.email);
            const config = {
                method: "post",
                url: `${this.store.state.baseURL}userupdate`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };

            if (this.$refs.form.validate()) {
                await axios(config)
                .then(resp => {
                    this.user = resp.data.user;
                    this.loading = false
                    this.alert = true;
                })
            } else {
                this.store.state.showAlert = true;
                this.store.state.alertMsg = "Fyll i lämplig information";
                this.store.state.alertType = "error";
                this.loading = false
            }
        },
        deleteAccount() {
            let url = `${this.store.state.baseURL}deleteuser/${this.store.state.user.id}`;
            axios.get(url);
            this.store.dispatch("logout");
            this.$router.replace("/");
        }
    }
  }
</script>
<style>
.themecolor {
  color:#ffa500 !important;
}
</style>